export default {
	name: "PopUp",
	props: {
		content: {
			type: String,
			default: "",
		}
	},
	methods: {togglePopup, },
};
function togglePopup() {
	this.$emit("toggle-popup");
}
